import { render } from "./PageIdentity.vue?vue&type=template&id=2d36781d&scoped=true"
import script from "./PageIdentity.vue?vue&type=script&lang=js"
export * from "./PageIdentity.vue?vue&type=script&lang=js"

import "./PageIdentity.vue?vue&type=style&index=0&id=2d36781d&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d36781d"]])

export default __exports__